import { Link } from 'quartz-routing/react-router';
import { useShouldReloadLocation } from '../hooks/useShouldReloadLocation';
import { useReloadLinkProps } from '../hooks/useReloadLinkProps';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * App-aware drop-in for React Router's `Link`. Renders a plain `<a>` with a
 * full page reload for cross-app navigation, or a React Router `Link` for
 * same-app navigation.
 *
 * @param href - Optional override for the resolved href. Only used during
 *   cross-app navigation (full page reload). Has no effect for same-app
 *   navigation, where `to` is used instead.
 */
export const ACReactRouterLink = props => {
  const {
    href,
    handleClick
  } = useReloadLinkProps(props);
  const shouldReload = useShouldReloadLocation(props.to);
  if (shouldReload) {
    return /*#__PURE__*/_jsx("a", Object.assign({}, props, {
      href: href,
      onClick: handleClick
    }));
  }
  return /*#__PURE__*/_jsx(Link, Object.assign({}, props, {
    href: undefined
  }));
};